/**
 * Formats a date string to a localized string containing year, month, day, hour, and minute (no seconds).
 * @param {string | Date} dateValue - The date to format
 * @returns {string} The formatted date string
 */
export const formatDateTimeWithoutSeconds = (dateValue) => {
  if (!dateValue) return "";
  return new Date(dateValue).toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
